import mixins from '@/mixins'
import validation from '@/mixins/validation'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'setting-llm-parameters-general',
    mixins: [mixins, validation],
    data () {
        return {
            valid: false,
            payload: {
                name: '',
                value: '',
                description: ''
            },
            nameRules: [
                v => !!v || 'Name is required'
            ],
            valueRules: [
                v => (v !== null && v !== undefined && String(v).length > 0) || 'Value is required'
            ]
        }
    },
    watch: {
        currentItem () {
            if (this.currentItem && this.editId) {
                this.setData()
            }
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'settingLlmParameters/isLoading',
            currentItem: 'settingLlmParameters/currentItem',
            editId: 'settingLlmParameters/editId'
        })
    },
    created () {
        if (this.currentItem && this.editId) {
            this.setData()
        }
    },
    methods: {
        ...mapActions({
            update: 'settingLlmParameters/UPDATE',
            create: 'settingLlmParameters/CREATE'
        }),
        setData () {
            if (!this.currentItem) {
                return
            }

            this.payload = {
                name: this.currentItem.name || '',
                value: this.currentItem.value != null ? String(this.currentItem.value) : '',
                description: this.currentItem.description != null ? String(this.currentItem.description) : ''
            }
        },
        buildPayload () {
            return {
                name: this.payload.name,
                value: this.payload.value,
                description: this.payload.description || null
            }
        },
        resetForm () {
            this.payload = {
                name: '',
                value: '',
                description: ''
            }

            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.reset()
                }
            })
        },
        submit () {
            this.$refs.form.validate()

            if (!this.valid) {
                return
            }

            const body = this.buildPayload()

            if (this.editId) {
                this.update(body).then(() => {
                    this.$toasted.success(this.$t('success_updated'))
                    this.$emit('saved')
                })
            } else {
                this.create(body).then(() => {
                    this.$toasted.success(this.$t('success_created'))
                    this.resetForm()
                    this.$emit('saved')
                })
            }
        }
    }
}
